import { gql } from '@apollo/client';

export const GET_DOCUMENT_TRACKING_HISTORY = gql`
  query GetDocumentTrackingHistory($date: String!) {
    getDocumentTrackingHistory(date: $date) {
      id
      facturaId
      numeroFactura
      fechaCreacion
      total
      prefijo
      esElectronica
      clienteNombre
      clienteDocumento
      esConsumidorFinal
      metodoPago
      codigoDian
      esSoloEfectivo
      pagosMixtos
      modActivo
      forceElectronic
      transmitida
      tieneCufe
      cufe
      factusStatus
      motivo
      motivoCorto
      categoriaDecision
      sincronizadoAt
    }
  }
`;

export const GET_DOCUMENT_TRACKING_STATS = gql`
  query GetDocumentTrackingStats($date: String!) {
    getDocumentTrackingStats(date: $date) {
      totalDocumentos
      transmitidas
      noTransmitidas
      porCategoria {
        categoria
        count
        porcentaje
      }
    }
  }
`;
